import { MaizyState } from '../maizy';
import mockedRequester from './mockedRequester';
const mockedResult = {
    daysWithoutRain: 9,
    maxRainfallSum: 89,
    dryMatterTarget: 43,
    seedlingDate: '1253715014',
    floweringRange: ['1453715014', '1463715014'],
    floweringDate: null,
    harvestRange: ['1473715014', '1483715014'],
    harvestingCalendar: {
        1463715014: {
            dryMatter: 4,
            state: MaizyState.good,
            rainState: MaizyState.medium
        }
    },
    seedlingCalendar: {
        1463715014: {
            pastTemperature: [4, 5, 9, 3],
            pastTemperatureState: MaizyState.medium,
            futureTemperature: [1, 2, 3],
            futureTemperatureState: MaizyState.medium,
            pastRain: [1, 2, 3],
            pastRainState: MaizyState.medium,
            futureRain: [1, 2, 3],
            futureRainState: MaizyState.medium,
            soilTemperatureState: MaizyState.medium,
            state: MaizyState.medium
        }
    }
};
const mockedConfig = {
    dryMatterTarget: 8,
    cropId: 7
};
const mock = {
    editConfig: mockedRequester(mockedConfig, 'maizy.editConfig'),
    result: mockedRequester(mockedResult, 'maizy.result')
};
export default mock;
